{
  "企业会员": "Enterprise memberships",
  "管理会员": "Manage membership",
  "有效会员": "Active member",
  "未开通": "Not activated",
  "已撤销": "Revoked",
  "待确认": "Pending confirmation",
  "已开通": "Activated",
  "已退回": "Returned",
  "开通": "Activate",
  "续期": "Renew",
  "撤销": "Revoke",
  "到期": "Expire",
  "历史调整": "Legacy adjustment",
  "半年": "6 months",
  "一年": "1 year",
  "开通 / 续期": "Activate / renew",
  "管理价格及沟通额度": "Prices & communication quota",
  "半年 / 一年人工开通及续期，依据收款或授权确认。": "Manually activate or renew for 6 months or 1 year with payment or authorization evidence.",
  "当前状态": "Current status",
  "开通日": "Activation date",
  "到期日": "Expiry date",
  "原到期日": "Previous expiry",
  "当前到期日": "Current expiry",
  "历史会员未设置": "Not recorded for legacy membership",
  "待设置": "Not set",
  "待确认申请": "Pending application",
  "记录": "History",
  "会员申请": "Membership applications",
  "会员操作记录": "Membership history",
  "会员期限": "Membership term",
  "期限": "Term",
  "申请期限": "Requested term",
  "申请时价格": "Price at submission",
  "申请说明": "Application note",
  "申请状态": "Application status",
  "确认开通": "Confirm activation",
  "确认开通 / 续期": "Confirm activation / renewal",
  "撤销企业会员": "Revoke membership",
  "撤销原因": "Reason for revocation",
  "收款或授权依据": "Payment or authorization evidence",
  "请填写撤销原因": "Enter the reason for revocation",
  "请填写收款凭证或授权说明": "Enter payment evidence or authorization details",
  "撤销后立即停止会员权益，历史记录保留。": "Membership benefits end immediately. History is retained.",
  "有效期内从到期日续期，到期或未设到期日从确认时开通。": "Active memberships extend from their expiry. Expired memberships or those with no expiry start on confirmation.",
  "状态已变化或企业已停用，请重新加载后核对。": "The status changed or the enterprise is disabled. Reload to check.",
  "请选择会员期限": "Select a membership term",
  "退回会员申请": "Return membership application",
  "半年价格（人民币元）": "6-month price (CNY)",
  "一年价格（人民币元）": "1-year price (CNY)",
  "每月沟通申请额度（次）": "Monthly communication request quota",
  "0 表示不限，留空表示未配置。": "0 means unlimited. Leave blank if not configured.",
  "会员方案": "Membership plans",
  "编辑会员方案": "Edit membership plan",
  "新增会员方案": "New membership plan",
  "新增方案": "New plan",
  "方案名称": "Plan name",
  "方案英文名称": "Plan name in English",
  "方案标识": "Plan code",
  "请填写方案名称": "Enter a plan name",
  "请填写方案标识": "Enter a plan code",
  "使用小写字母、数字和连字符，以字母开头": "Use lowercase letters, numbers and hyphens, starting with a letter",
  "开放方案": "Open plan",
  "默认方案": "Default plan",
  "期限与价格": "Terms and prices",
  "新增期限": "Add term",
  "至少配置一个期限": "Configure at least one term",
  "期限不能重复": "Terms must be unique",
  "开放方案至少需要一个开放期限": "An open plan needs at least one open term",
  "期限（月）": "Term (months)",
  "请填写期限": "Enter a term",
  "价格（人民币元）": "Price (CNY)",
  "价格": "Price",
  "币种": "Currency",
  "请选择币种": "Select a currency",
  "选择或输入币种": "Select or enter a currency",
  "请选择或输入币种": "Select or enter a currency",
  "币种最多 16 个字符": "Currency must be 16 characters or fewer",
  "币种不能包含控制字符": "Currency cannot contain control characters",
  "CNY 人民币": "CNY Renminbi",
  "USD 美元": "USD US dollar",
  "EUR 欧元": "EUR Euro",
  "HKD 港币": "HKD Hong Kong dollar",
  "GBP 英镑": "GBP Pound sterling",
  "赠送积分": "Bonus points",
  "请填写赠送积分": "Enter bonus points",
  "赠送积分须为 0 至 2147483647 的整数": "Bonus points must be an integer from 0 to 2147483647",
  "赠送积分 {{count}}": "Bonus points: {{count}}",
  "开放期限": "Open term",
  "已保存期限仅可调整价格、赠送积分或开放状态。": "Saved terms can only have their price, bonus points or availability changed.",
  "停用默认方案前，请先将其他开放方案设为默认。": "Set another open plan as the default before closing this plan.",
  "请关闭后重新打开，核对最新方案配置。": "Close and reopen to review the latest plan settings.",
  "状态已变化，请重新加载后核对。": "The status changed. Reload to review it.",
  "历史申请缺少方案记录，请退回后重新提交。": "This historical application has no plan record. Return it for resubmission.",
  "暂无开放方案，请先配置会员方案。": "No plans are open. Configure a membership plan first.",
  "该方案已停止开放，无法开通或续期。": "This plan is closed and cannot be activated or renewed.",
  "有效会员只能续期当前方案。": "Active memberships can only renew their current plan.",
  "该期限已停止开放，请重新选择。": "This term is closed. Select another term.",
  "有效期内从到期日续期并保留现有权益，到期后按所选方案重新开通。": "Active memberships extend from their expiry and retain their benefits. Expired memberships start again with the selected plan.",
  "请选择会员方案": "Select a membership plan",
  "方案价格": "Plan price",
  "沟通申请额度": "Communication request quota",
  "已开放": "Open",
  "未开放": "Closed",
  "记录价格": "Recorded price",
  "按会员方案人工开通及续期，依据收款或授权确认。": "Manually activate or renew a membership plan with payment or authorization evidence.",
  "历史会员": "Legacy membership",
  "{{count}} 个月": "{{count}} months",
  "每月 {{count}} 次": "{{count}} requests per month",
  "企业已停用，无法开通会员。": "This enterprise is disabled. Membership cannot be activated.",
  "会员已撤销或尚未开通。": "This membership has been revoked or has not been activated.",
  "申请已处理，请重新加载后核对。": "This application was already processed. Reload to review it.",
  "不限": "Unlimited",
  "1 个月": "1 month"
}
